
import { useState, useEffect } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './register.css';
import './auth.css';
import { auth, googleProvider } from '../config/firebase';
import { signInWithPopup, signOut, signInWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { getAdditionalUserInfo, deleteUser } from "firebase/auth";
import { Link, useLocation } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';

export const Auth = () => {

  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Extract messages gracefully if they were passed via navigation state.
  const successMessage = location.state?.successMessage || "";
  const initialLoginError = location.state?.loginError || "";

  useEffect(() => {
    if (initialLoginError) {
      setLoginError(initialLoginError);
    }
  }, [initialLoginError]);

  const signIn = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await signInWithEmailAndPassword(auth, loginEmail, loginPassword);

      if (res.user.emailVerified) {
        navigate('/discovery');
      } else {
        await sendEmailVerification(res.user);
        await signOut(auth);
        alert('You were not verified Your Email during account creation. A new verification email has been sent to your inbox. Please verify your email to continue.');
      }
      // navigate('/discovery');
      // if(!cred.user.emailVerified) {
      //   await signOut(auth);

      // }
    } catch (err) {
      setLoginError("Incorrect email or password, please try again.");
      console.error(err);
    } finally {
      setIsLoading(false);
    }

  };


  const signInWithGoogle = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const cred = await signInWithPopup(auth, googleProvider);
      const info = getAdditionalUserInfo(cred);
      navigate('/discovery');
      if (info?.isNewUser) {
        await deleteUser(cred.user);
        await signOut(auth);

        throw new Error(
          "Google sign-in is for existing accounts only. Please register first (email/password), then link Google in your profile."
        );
      }
    } catch (err) {
      console.error(err);
    }
    finally {
      setIsLoading(false);
    }
  };



  const register = () => {
    navigate('/register');
  }

  const handelGooglePlay = () => {
    window.open("https://play.google.com/store/apps/details?id=me.flintt.app", "_blank");
  }

  const handelAppleStore = () => {
    // window.open("https://www.apple.com/app-store/", "_blank");
    enqueueSnackbar("Coming soon to the Apple App Store", { variant: "info" });
  }

  return (
    <>
      <div className='main auth'>

        <div className='aside'><div></div></div>

        <div className='content has-aside'>

          <span className='small-text'>Don't have an account? <a href="/register" title="Sign up" onClick={register}>Sign up</a></span>

          <div className='log-in-content'>

            <a href="https://flintt.me/"><div className='logo'></div></a>

            {successMessage && (
              <div style={{
                background: '#e6ffe6',
                color: '#006600',
                padding: '10px',
                borderRadius: '5px',
                marginBottom: '15px',
                fontSize: '14px',
                textAlign: 'center',
                border: '1px solid #006600'
              }}>
                {successMessage}
              </div>
            )}

            <form className='log-in-form'>
              {loginError && <div className="login-error">{loginError}</div>}
              <input type="email" placeholder='email' className="login-input" onChange={(e) => setLoginEmail(e.target.value)} />
              <div className="password-input-container">
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder='password'
                  onChange={(e) => setLoginPassword(e.target.value)}
                  className="password-input"
                />
                <span className="password-icon" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              <div>
                <button type="submit" disabled={isLoading} onClick={signIn}>
                  {isLoading
                    ? <ClipLoader size={20} />
                    : 'Sign in'}
                </button>
              </div>
            </form>

            <button onClick={signInWithGoogle} className='login-button'>Sign in with Google</button>

            <span className='small-text'><Link to="/resetPassword" title="Reset Password">Forgotten Password?</Link></span>

          </div>

          <span className='tiny-text'>By signing up, you agree to our <a href="/terms-of-service" title="Terms of Service">Terms</a>. See how we use your data in our <a href="/privacy-policy" title="Privacy Policy">Privacy Policy</a>.</span>

          <div className="store-badges">
            <div onClick={() => handelGooglePlay()} style={{ cursor: 'pointer' }}>
              <img alt="Get it on Google Play" src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" className="store-badge" />
            </div>
            <div onClick={() => handelAppleStore()} style={{ cursor: 'pointer' }}>
              <img alt="Download on the App Store" src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" className="store-badge" />
            </div>
          </div>

          {/* 
          // OLD CODE
          // <span className='tiny-text'>By signing up, you agree to our <a href="/terms-of-service" title="Terms of Service">Terms</a>. See how we use your data in our <a href="/privacy-policy" title="Privacy Policy">Privacy Policy</a>.</span>
          */}

        </div>
      </div>


    </>

  );
};